

import React from "react";
import classes from "./ConfirmationModal.module.css";
// import { IoIosWarning } from "react-icons/io";
// import { useNavigate } from "react-router-dom";

const ConfirmationModal = ({subscribeLoading,visible,handleCloseModal,getSubData}) => {

    
        

  return (
    <>



    <div className="card flex justify-content-center">
             {/* <Button label="Show" icon="pi pi-external-link" onClick={() => setVisible(true)} /> */}
           
           
         </div>





    <div className={`${visible ? `${classes.modal_container} ${classes.modal_show}` : classes.modal_container}`}>
      <div className={classes.modal_sub_container}>
        
      <div  style={{ width: '25rem' }} onHide={() => {if (!visible) return; handleCloseModal(); }} className='bg-white '>
             <div className='flex flex-col items-center'>
             <div className='flex justify-center items-center h-20 w-20 rounded-full border-4  border-[#00c1a0]'><i className='pi pi-check text-2xl text-[#00c1a0] font-bold'></i></div>
             <br/>
     <p className='text-black text-3xl font-bold text-center'>Please Click on Confirm Button to Subscribe</p>
     <br/>
     <p className='text-gray-500 text-sm text-center'>Your Pack Will be automatically Renewed. You can unsubscribe any time from profile Section.</p>
    
     </div>
             </div>
             <form className='flex gap-2 justify-center' onSubmit={getSubData}>
         <button  className='p-2  text-white text-lg font-bold bg-[#495057] rounded-md px-4' onClick={()=>handleCloseModal()}>Cancel</button>
         <button  id="cta_button"
            type="submit" className='p-2 text-white text-lg font-bold bg-[#00c9a7] rounded-md px-4' >{subscribeLoading ? 'loading....' : 'Confirm' }</button>    
         </form>
      </div>
    </div>
    </>
  );
};

export default ConfirmationModal;



